export default __webpack_public_path__ + "b3105937d650874d1fd250040942cce0.svg";